import { useLocation } from 'react-router-dom';
import { reportApiTracker, useReportApiTrackerState } from '../../utils/reportApiTracker';
import { useIsDesktop, T } from './reportTokens';
import ReportErrorState from './ReportErrorState';

const SIDEBAR_WIDTH = 250;
const TOPBAR_HEIGHT = 56;
const MOBILE_BOTTOM_NAV_HEIGHT = 72;
const MOBILE_TOPBAR_HEIGHT_VAR = 'var(--mobile-topbar-height, 56px)';
const MIN_FAILURES_FOR_FULL_PAGE = 3;

const ReportErrorOverlay = () => {
    const location = useLocation();
    const isDesktop = useIsDesktop();
    const { failed, succeeded } = useReportApiTrackerState();

    const pathname = location.pathname || '';
    const isReportsSubRoute = /^\/reports\/[^/]+/.test(pathname);

    if (!isReportsSubRoute) return null;

    const allFailed = succeeded === 0 && failed >= MIN_FAILURES_FOR_FULL_PAGE;
    if (!allFailed) return null;

    const handleRetry = () => {
        reportApiTracker.reset();
        if (typeof window !== 'undefined') window.location.reload();
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: isDesktop ? TOPBAR_HEIGHT : MOBILE_TOPBAR_HEIGHT_VAR,
                left: isDesktop ? SIDEBAR_WIDTH : 0,
                right: 0,
                bottom: isDesktop ? 0 : 'calc(72px + max(0px, env(safe-area-inset-bottom)))',
                zIndex: 9000,
                background: T.bg,
                display: 'flex',
            }}
        >
            <ReportErrorState onRetry={handleRetry} />
        </div>
    );
};

export default ReportErrorOverlay;
